import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5021 15.9346C17.9623 15.9346 18.3354 16.3077 18.3354 16.7679C18.3354 17.1953 18.0137 17.5475 17.5992 17.5956L17.5021 17.6012H10.0021C9.54182 17.6012 9.16873 17.2281 9.16873 16.7679C9.16873 16.3405 9.49043 15.9883 9.90488 15.9402L10.0021 15.9346H17.5021ZM13.1628 2.42865C13.8199 1.77155 14.7777 1.51492 15.6753 1.75544C16.5729 1.99595 17.274 2.69707 17.5145 3.59469C17.755 4.49231 17.4984 5.45006 16.8413 6.10716L6.42465 16.5238C6.31785 16.6306 6.18403 16.7064 6.03751 16.743L2.70417 17.5764C2.09386 17.7289 1.54103 17.1761 1.69361 16.5658L2.52694 13.2325C2.56357 13.0859 2.63934 12.9521 2.74614 12.8453L13.1628 2.42865ZM15.1358 3.34308C14.8463 3.30117 14.5511 3.39733 14.3413 3.60716L4.08789 13.8604L3.64706 15.6221L5.40873 15.1812L15.6628 4.92865C15.8726 4.71882 15.9688 4.42365 15.9269 4.13417L15.9047 4.02606C15.8183 3.70359 15.5664 3.45172 15.2439 3.36531L15.1358 3.34308Z"
        fill="#DF692B"
      />
    </Svg>
  );
};

export default Icon;
